import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { ReferralInfoFragment } from '@occc/graphql';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { IPaginationProps } from '@occc/ui-design-system';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { DataTable, Row } from '@occc/ui-design-system';

import { membershipReferralsTableHeaderMessages as headerMessages } from './membership-referrals-table.messages';
import { makeFields } from './membership-referrals-table.utils';

const headers = [
  { label: headerMessages.signUpDate },
  { label: headerMessages.receiver },
  { label: headerMessages.senderAwardGrantedDate },
  { label: headerMessages.receiverAwardGrantedDate },
];

type MembershipReferralsTableProps = {
  referrals: ReferralInfoFragment[];
  paginationProps: IPaginationProps;
  loading: boolean;
  error?: ApolloError;
};

export const MembershipReferralsTable = (props: MembershipReferralsTableProps) => {
  const { referrals, paginationProps, loading, error } = props;

  const rows = useMemo<Row[]>(
    () =>
      referrals.map((referral) => ({
        key: referral.receiverId,
        fields: makeFields(referral),
      })),
    [referrals],
  );

  return (
    <DataTable
      headers={headers}
      rows={rows}
      loading={loading}
      error={error}
      paginationProps={paginationProps}
    />
  );
};
